import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { forceLogout } from "components/axios/forceLogout";
  
const LogoutProcess = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        forceLogout(dispatch, navigate);
    }, [dispatch, navigate]);

    return null;
}

export default LogoutProcess;